import { render, staticRenderFns } from "./ModalThemeGuide.vue?vue&type=template&id=cc6a1940&scoped=true&"
import script from "./ModalThemeGuide.vue?vue&type=script&lang=js&"
export * from "./ModalThemeGuide.vue?vue&type=script&lang=js&"
import style0 from "./ModalThemeGuide.vue?vue&type=style&index=0&id=cc6a1940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6a1940",
  null
  
)

export default component.exports